import { Script } from 'gatsby';
import { attributesToProps, domToReact } from 'html-react-parser';
import React from 'react';
import generateUniqueId from '../../../../generateUniqueId';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';
import { wpImageClass, wpOrnamentalImageClass } from './Constants';

const restoreScriptFromPre = ({name, type, attribs, children}) =>
{
    if ( type !== 'tag' ) return null;
    if ( name !== 'pre' ) return null;
    if ( !Object.keys(attribs).includes('data-toparse') || attribs['data-toparse'] !== 'script' ) return null;
    const props = attributesToProps(attribs);
    const childComponents = domToReact(children);
    return <Script id={generateUniqueId()} {...props}>{childComponents}</Script>;
}

const toGatsbyImage = ( ) =>
{
    const Wrapper = ({
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type,
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children
    }) =>
    {
        if ( type !== 'tag' ) return null;
        if ( name !== 'figure' && name !== 'span' ) return null;
        if ( name === 'figure' && !attribs?.class?.includes(wpImageClass) ) return null;
        if ( name === 'span' && !attribs?.class?.includes(wpOrnamentalImageClass) ) return null;
        
        const props = attributesToProps(attribs);
        const childComponents = domToReact(children, {replace: restoreScriptFromPre});
        
        return <figure {...props}>{childComponents}</figure>
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}

export default toGatsbyImage;
